import { render } from "./InputsEditor.vue?vue&type=template&id=1f174a89&scoped=true"
import script from "./InputsEditor.vue?vue&type=script&lang=js"
export * from "./InputsEditor.vue?vue&type=script&lang=js"

import "./InputsEditor.vue?vue&type=style&index=0&id=1f174a89&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f174a89"]])

export default __exports__